import { ButtonVariants } from '../../constants'

import RoundedButton from 'components/Atoms/Buttons/RoundedButton/RoundedButton'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function Error() {
  const { t } = useTranslation('global')
  const navigate = useNavigate()
  const handleBack = () => {
    navigate(-1)
  }
  return (
    <div className="flex flex-col items-center pt-24 pb-10 justify-center space-y-10">
      <img src="../error-404.png" className="w-100 sm:max-w-3/4" alt="error" />
      <RoundedButton variant={ButtonVariants.PRIMARY} onClick={handleBack}>
        {t('btn.return')}
      </RoundedButton>
    </div>
  )
}
